
import Tippy from '@/components/common/Tippy.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import { hideAll } from 'tippy.js'

export default {
    name: 'InfoNote',
    components: { Tippy, Icon },
    props: {
        note: {
            type: String,
            default: null
        },
        el: null
    },
    data () {
        return {
            root: null
        }
    },
    mounted () {
        // not to overlap side menu
        this.root = this.$el.closest('.file-viewer')
    },
    methods: {
        hideAll () {
            hideAll()
        },
        onClick (e) {
            const target = e.target
            if (target && target.tagName === 'A') {
                this.hideAll()
            }
        }
    }
}
